import React, { useEffect } from 'react'
import { graphql } from 'gatsby'

import { Helmet } from 'react-helmet'
import { Trans } from 'gatsby-plugin-react-i18next'
import { CAL_BUY_LINK, IS_FOREIGN_COUNTRY } from 'src/utils/constants'
import PropTypes from 'prop-types'
import FAQs from '../components/FAQs'
import SEO from '../components/seo'
import { CenteredContent, BuyNowLink } from '../components/Hero/styles'
import { ContentContainer, HideOverflow } from '../utils/styles/global-styles'
import Analytics from '../utils/Analytics'
import CalendarPress from '../components/CalendarPress'
import CalendarMatrix from '../components/CalendarMatrix'
import CalendarGuarantee from '../components/CalendarGuarantee'
import RedesignCalendarTestimonials from '../components/RedesignCalendarTestimonials'
import CalendarNewFeatures from '../components/CalendarNewFeatures'
import Quiz from '../components/Quiz'
import HomepageCalHero from '../components/HomepageCalHero'

const CalendarAmazon = ({ data: { calendarOgImage } }) => {
  useEffect(() => {
    Analytics.track('Viewed Calendar Amazon Landing Page')
  }, [])

  return (
    <>
      <SEO
        title="Smart Touchscreen Family Calendar and Organizer | Skylight Calendar"
        description="Skylight Calendar is a smart, touchscreen wall calendar that displays your family's important events and chores."
        imagePath={calendarOgImage.childImageSharp.gatsbyImageData.images.fallback.src}
        path="/calendar/"
      />
      <Helmet>
        <meta charset="UTF-8" />
        <meta name="robots" content="noindex" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
        />
      </Helmet>
      <HomepageCalHero page="calendar" amazon />
      <HideOverflow>
        <RedesignCalendarTestimonials />
      </HideOverflow>
      <CalendarNewFeatures />
      <CalendarGuarantee
        first
        ctaText={IS_FOREIGN_COUNTRY ? 'Buy Now' : 'Learn more'}
        ctaLink={
          IS_FOREIGN_COUNTRY
            ? CAL_BUY_LINK
            : 'https://skylight.zendesk.com/hc/en-us/articles/360043182612-Refund-and-Return-Policy'
        }
      />
      {!IS_FOREIGN_COUNTRY && <Quiz hideImage calendar />}
      <CalendarPress />
      <CalendarMatrix />
      <FAQs page="calendar" />
      <ContentContainer>
        <CenteredContent>
          <BuyNowLink to={CAL_BUY_LINK}>
            <Trans>Buy Now</Trans>
          </BuyNowLink>
        </CenteredContent>
      </ContentContainer>
    </>
  )
}

CalendarAmazon.propTypes = {
  data: PropTypes.shape({
    calendarOgImage: PropTypes.object.isRequired,
    countdown: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            en_au_countdown: PropTypes.string,
            en_ca_countdown: PropTypes.string,
            en_countdown: PropTypes.string,
            en_gb_countdown: PropTypes.string,
          }),
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
}

export default CalendarAmazon

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { ns: { in: ["common", "calendar"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    calendarOgImage: file(relativePath: { eq: "cal-social-img.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    countdown: allContentfulCountdownTimer {
      edges {
        node {
          en_au_countdown
          en_ca_countdown
          en_countdown
          en_gb_countdown
        }
      }
    }
  }
`
